$('.accordion .toggle').click(function(e) {
  
  e.preventDefault();

  var $this = $(this);

  $('.accordion .toggle').removeClass('active');

  if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
      $this.removeClass('active');

    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
        $this.addClass('active');

  }
});

$(document).ready(function(){
    var first = $('.accordion .toggle')[0];

    $(first).trigger('click').addClass('active');
});